<template>
  <div v-loading="loading" class="ht-flow-list">
    <template v-if="filteredData.length > 0">
      <div class="ht-flow-body">
        <flow-card
          v-for="(flow, index) in paginatedData"
          :key="flow.id"
          :flow="{ ...flow, index }"
        />
      </div>
      <div class="ht-flow-footer">
        <el-pagination
          v-if="total > 0"
          background
          layout="total, sizes,prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          style="margin-top: 20px; text-align: right"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>

    <el-empty v-else />
  </div>
</template>

<script>
  import FlowCard from './component/FlowCard.vue'
  import debounce from 'lodash/debounce'
  import { homePageRelatedProcess } from '@/api/flow'
  import { addEventLog } from '@/api/base'
  import moment_tz from 'moment-timezone'
  export default {
    name: 'HtFlowList',

    components: { FlowCard },

    props: {
      pattern: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        loading: false,
        allData: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        debouncedHandleSearch: debounce(this.handleSearch, 250),
      }
    },

    computed: {
      filteredData() {
        return this.allData
      },
      paginatedData() {
        return this.allData
      },
    },

    watch: {
      pattern: {
        immediate: true,
        handler() {
          this.currentPage = 1
          this.debouncedHandleSearch()
        },
      },
    },

    methods: {
      async handleSearch() {
        this.loading = true

        try {
          // 构建请求参数
          const requestParams = {
            pageBean: {
              page: this.currentPage,
              pageSize: this.pageSize,
              showTotal: true,
            },
            querys: [
              {
                property: 'SUBJECT_',
                value: this.pattern || '',
                group: 'main',
                operation: 'LIKE',
                relation: 'OR',
              },
              {
                property: 'ID_',
                value: this.pattern || '',
                group: 'main',
                operation: 'LIKE',
                relation: 'OR',
              },
              {
                property: 'PROC_DEF_NAME_',
                value: this.pattern || '',
                group: 'main',
                operation: 'LIKE',
                relation: 'OR',
              },
              {
                property: 'PROP1_',
                value: this.pattern || '',
                group: 'main',
                operation: 'LIKE',
                relation: 'OR',
              },
              {
                property: 'aiSummaryResult',
                value: this.pattern || '',
                group: 'main',
                operation: 'LIKE',
                relation: 'OR',
              },
            ],
          }

          const response = await homePageRelatedProcess(requestParams)

          this.allData = response.rows.map((item) => ({
            instanceId: item.id,
            title: item.subject,
            flowName: item.procDefName,
            businessNumber: item.prop1,
            startTime: moment_tz
              .utc(moment_tz.utc(item.createTime))
              .tz(moment_tz.tz.guess())
              .format('YYYY-MM-DD HH:mm:ss'),
            initiator: item.creator,
            aiSummary: item.aiSummaryResult,
          }))
          this.total = response.total || 0
        } catch (e) {
          console.error('搜索流程实例失败:', e)
          this.allData = []
          this.total = 0
        } finally {
          this.loading = false
          await addEventLog({
            type: '流程',
            content: this.pattern,
          })
        }
      },

      handlePageChange(page) {
        this.currentPage = page
        this.handleSearch()
        // ht-flow-body滚动条滚动到顶部
        const bodyElement = this.$el.querySelector('.ht-flow-body')
        if (bodyElement) {
          bodyElement.scrollTop = 0
        }
      },
      handlePageSizeChange(size) {
        this.pageSize = size
        this.currentPage = 1
        this.handleSearch()
        const bodyElement = this.$el.querySelector('.ht-flow-body')
        if (bodyElement) {
          bodyElement.scrollTop = 0
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ht-flow-list {
    display: flex;
    flex-direction: column;
    height: 98%;
    padding: 0 12px 12px;
    overflow: hidden;
  }

  .ht-flow-body {
    flex: 1;
    margin-bottom: 12px;
    overflow-y: auto;
  }

  .ht-flow-footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
  }
</style>
